export default __webpack_public_path__ + "static/media/oneforce-template-img-white-thumbnail.2f28d812.jpg";